// extracted by mini-css-extract-plugin
export default {"cardcontainers":"card_cardcontainers__LHiqc","card":"card_card__+ws8D"};